import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CButton, CSpinner } from '@coreui/react-pro';
import classNames from 'classnames';

const Button = React.forwardRef((props, ref) => {
     const { color, type, spinnerSize, className, loading, children, ...restProps } = props;

     return (
          <CButton ref={ref} color={color} type={type} className={classNames({ [className]: className })} {...restProps}>
               {loading && (
                    <>
                         <div className="btn-spinner">
                              <CSpinner color={color} size={spinnerSize} />
                         </div>
                         <span className="btn-r-only">{children}</span>
                    </>
               )}
               {!loading && children}
          </CButton>
     );
});

Button.propTypes = {
     color: PropTypes.string,
     spinnerSize: PropTypes.string,
     className: PropTypes.string,
     disabled: PropTypes.bool,
     onClick: PropTypes.func,
};

Button.defaultProps = {
     color: 'primary',
     type: 'button',
     spinnerSize: 'sm',
};

export default memo(Button);
